module.exports = __webpack_public_path__ + "static/media/Success2.0eab40fe.svg";